export default "__VITE_ASSET___AiLu3y$__"